export const downloadFile = (url: string, name: string) => {
  const xhr = new XMLHttpRequest()
  xhr.open('GET', url, true)
  // 响应类型设置为blob
  xhr.responseType = 'blob'
  // 请求成功
  xhr.addEventListener('load', function () {
    if (xhr.status === 200) {
      const a = document.createElement('a')
      a.href = window.URL.createObjectURL(xhr.response)
      a.download = name
      // 将a标签添加到body中是为了更好的兼容性，谷歌浏览器可以不用添加
      document.body.appendChild(a)
      a.click()
      // 移除
      a.remove()
      // 释放url
      window.URL.revokeObjectURL(a.href)
    }
  })
  // 发送请求
  xhr.send()
}
